import React, { useEffect, useMemo, useState } from "react";
import {
  getDiscontinueFeedbacks,
  getProgramActionHistory,
  getProgramActionReasonApi,
  getProgramActionTreeApi,
  updateProgramActionApi,
} from "./api";
import CustomTooltip from "views/pages/manage/common/customTooltip/CustomTooltip";
import { getFormattedDate } from "../../constant/batch-search";
import { getCoursePricingDetails } from "../../stockManagement/service";

export function useFetchProgramActions(studentCurrentProgramAction) {
  const [dropdownTree, setDropdownTree] = useState([]);
  const stableProgramAction = useMemo(
    () => studentCurrentProgramAction,
    [studentCurrentProgramAction],
  );

  useEffect(() => {
    if (stableProgramAction)
      getProgramActionTreeApi().then((res) => {
        if (res) {
          let data = res || [];
          const dropdownPrepared = (
            data[studentCurrentProgramAction] || []
          ).map((item) => ({ label: item, value: item }));
          setDropdownTree(dropdownPrepared);
        }
      });
  }, [stableProgramAction]);

  return dropdownTree;
}

export function useFetchProgramActionReason(selectedProgramAction) {
  const [dropdownReason, setDropdownReason] = useState([]);
  const stableProgramAction = useMemo(
    () => selectedProgramAction?.value,
    [selectedProgramAction?.value],
  );
  useEffect(() => {
    if (stableProgramAction)
      getProgramActionReasonApi().then((res) => {
        if (res) {
          let reasons = res;
          if (reasons[stableProgramAction]) {
            const dropdown = [];
            for (const [key, value] of Object.entries(
              reasons[stableProgramAction],
            )) {
              dropdown.push({ label: value, value: key });
            }
            setDropdownReason(dropdown);
          }
        }
      });
  }, [selectedProgramAction?.value]);

  return dropdownReason;
}

export function useFetchProgramHistory(application) {
  const [history, setHistory] = useState([]);
  useEffect(() => {
    if (application)
      getProgramActionHistory(application).then((res) => {
        if (res) {
          setHistory(res);
        }
      });
  }, [application]);

  return history;
}
export function useFetchCourseIdDetail(applicationDetails) {
  const [courseIdDetail, setCourseIdDetail] = useState([]);
  const { courseId, businessAreaId, term } = applicationDetails || {};
  useEffect(() => {
    if (courseId && businessAreaId && term) {
      getCoursePricingDetails(courseId, businessAreaId, term).then((res) => {
        if (res) {
          setCourseIdDetail(res);
        }
      });
    }
  }, [
    applicationDetails?.courseId,
    applicationDetails?.businessAreaId,
    applicationDetails?.term,
  ]);

  return courseIdDetail;
}

export function useUpdateProgramActionReason() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const updateProgramAction = async (request) => {
    try {
      setIsLoading(true);
      return await updateProgramActionApi(request);
      // set error if something went wrong
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  return [isLoading, error, updateProgramAction];
}

export const useDiscontinueFeedback = ({ applicationId }) => {
  const [feedbacks, setFeedbacks] = useState([]);

  useEffect(() => {
    if (applicationId) {
      getDiscontinueFeedbacks(applicationId).then((res) => {
        if (res) {
          setFeedbacks(res);
        }
      });
    }
  }, [applicationId]);

  return feedbacks;
};

const ShowDetails = ({ details }) => {
  return (
    <div>
      <div>
        {" "}
        <span className="semi-bold text-dark">Action date</span>:
        {getFormattedDate(details?.updatedOn)}
      </div>
      <div>
        <span className="semi-bold text-dark">Action Reason</span>:{" "}
        {details?.progReason}
      </div>
    </div>
  );
};

export const getProgramActionViewIcon = (
  programAction,
  programActionHistory,
) => {
  console.log("hasHistory", programActionHistory, programAction);

  if (programAction === "APPL") return null;

  const latestHistory = programActionHistory?.reduce((latest, current) => {
    if (current?.progAction === programAction) {
      if (!latest || new Date(current.updatedOn) > new Date(latest.updatedOn)) {
        return current;
      }
    }
    return latest;
  }, null);

  const hasHistory = latestHistory;

  if (hasHistory) {
    return (
      <CustomTooltip
        showOnClick={true}
        title={<ShowDetails details={hasHistory} />}
      >
        <div className="ellipsis-text-container">
          <span
            className="ms-2 cursor-pointer"
            style={{ color: "#0d6efd" }}
            title="View Action History"
          >
            <i className="fa fa-eye" aria-hidden="true"></i>
          </span>
        </div>
      </CustomTooltip>
    );
  }

  return null;
};
